import trustYouBubbles from './trustyou-bubbles.svg';

const Assets = {
    trustYouBubbles,
};

export default Assets;
